import React, { useEffect, useState, useContext } from 'react';
import { db } from '../../../firebase';
import { collection, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faTrash, faToggleOn, faToggleOff } from '@fortawesome/free-solid-svg-icons';
import AddPromo from './AddPromo';
import { UserContext } from '../../../contexts/UserContext';
import ReactPaginate from 'react-paginate'; 

const Promos = () => {
    const [promos, setPromos] = useState([]);
    const [filteredPromos, setFilteredPromos] = useState([]);
    const { user } = useContext(UserContext);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(10);
    const [searchCode, setSearchCode] = useState('');

    const fetchPromos = async () => {
        try {
            const promosCollection = collection(db, 'promos');
            const promosSnapshot = await getDocs(promosCollection);
            const promosList = promosSnapshot.docs.map(doc => {
                const data = doc.data();
                return {
                    id: doc.id,
                    ...data,
                    valid_from: data.valid_from ? formatDate(data.valid_from) : '', 
                    valid_to: data.valid_to ? formatDate(data.valid_to) : ''      
                };
            });
            setPromos(promosList);
            setFilteredPromos(promosList);
        } catch (error) {
            console.error("Error fetching promos: ", error);
            setError("Failed to load promos.");
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (date) => {
        if (date.toDate) {
            return date.toDate().toLocaleDateString('fr-FR');
        }
        return new Date(date).toLocaleDateString('fr-FR'); // Handle other date formats
    };

    useEffect(() => {
        fetchPromos();
    }, []);

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer ce code de réduction?")) {
            try {
                await deleteDoc(doc(db, 'promos', id));
                setPromos(prevPromos => prevPromos.filter(promo => promo.id !== id));
                setFilteredPromos(prevPromos => prevPromos.filter(promo => promo.id !== id));
            } catch (error) {
                console.error("Error deleting promo: ", error);
                setError("Failed to delete promo.");
            }
        }
    };

    const toggleStatus = async (id, currentStatus) => {
        try {
            await updateDoc(doc(db, 'promos', id), {
                statut: !currentStatus
            });
            setPromos(prevPromos => prevPromos.map(promo =>
                promo.id === id ? { ...promo, statut: !currentStatus } : promo
            ));
            setFilteredPromos(prevPromos => prevPromos.map(promo =>
                promo.id === id ? { ...promo, statut: !currentStatus } : promo
            ));
        } catch (error) {
            console.error("Error updating promo status: ", error);
            setError("Failed to update promo status.");
        }
    };

    useEffect(() => {
        const results = promos.filter(promo =>
            promo.promo_code.toLowerCase().includes(searchCode.toLowerCase())
        );
        setFilteredPromos(results);
    }, [searchCode, promos]);

    const indexOfLastPromo = (currentPage + 1) * itemsPerPage;
    const indexOfFirstPromo = indexOfLastPromo - itemsPerPage;
    const currentPromos = filteredPromos.slice(indexOfFirstPromo, indexOfLastPromo);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div id="content-wrapper" className="d-flex flex-column">
            <div id="content">
                <div className="container-fluid">
                    <br/>
                    <button type="button" className="btn btn-red2 mb-4" data-bs-toggle="modal" data-bs-target="#addPromoModal">
                        <FontAwesomeIcon icon={faPlus} /> Ajouter
                    </button>
                    <div className="card shadow mb-4">
                        <div className="card-header py-3 d-flex justify-content-between align-items-center">
                            <h6 className="m-0 font-weight-bold title-2">Liste des codes de réductions</h6>
                            <input 
                                type="text" 
                                placeholder="Filtrer par code" 
                                className="form-control w-25" 
                                value={searchCode}
                                onChange={(e) => setSearchCode(e.target.value)}
                            />
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                                    <thead>
                                        <tr>
                                            <th>Nom</th>
                                            <th>Code</th>
                                            <th>Montant</th>
                                            <th>Utilisations</th>
                                            <th>Limite</th>
                                            <th>Date de début</th>
                                            <th>Date d'expiration</th>
                                            <th>Statut</th>
                                            {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && <th>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentPromos.map((promo) => (
                                            <tr key={promo.id}>
                                                <td>{promo.promo_nom}</td>
                                                <td>{promo.promo_code}</td>
                                                <td>{promo.promo_valeur}  
                                                    {promo.promo_type =='percentage' && ( <span> %</span> )}
                                                    {promo.promo_type =='flat' && ( <span> €</span> )}
                                                </td>
                                                <td>{promo.usage_count}</td>
                                                <td>{promo.usage_limit}</td>
                                                <td>{promo.valid_from}</td>
                                                <td>{promo.valid_to}</td>
                                                <td>
                                                    {promo.statut ? (
                                                        <button className="btn btn-success" onClick={() => toggleStatus(promo.id, promo.statut)}>
                                                            <FontAwesomeIcon icon={faToggleOn} /> Activé
                                                        </button>
                                                    ) : (
                                                        <button className="btn btn-secondary" onClick={() => toggleStatus(promo.id, promo.statut)}>
                                                            <FontAwesomeIcon icon={faToggleOff} /> Désactivé
                                                        </button>
                                                    )}
                                                </td>
                                                {user && user.role === 'L1QUmxerXDdx3DbWgY5H' && (
                                                    <td>
                                                        <button className="btn btn-danger btn-circle btn-sm" onClick={() => handleDelete(promo.id)}>
                                                            <FontAwesomeIcon icon={faTrash} />
                                                        </button>
                                                    </td>
                                                )}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* Pagination Controls */}
                            <ReactPaginate
                                previousLabel={"Précédent"}
                                nextLabel={"Suivant"}
                                breakLabel={"..."}
                                pageCount={Math.ceil(filteredPromos.length / itemsPerPage)}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={10}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination justify-content-start"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <AddPromo fetchPromos={fetchPromos} />
        </div>
    );
};

export default Promos;
